module.exports = __webpack_public_path__ + "static/media/sss-auto-checkmark.236bc167.svg";